<template>
    <div >
    <vx-card class="no-scroll-content" title="COE Lists" >

        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewCOE()" icon-pack="feather" icon="icon-file">Apply COE</vs-button>
        <vs-table class="no-scroll-content" stripe max-items="12" pagination v-model="selected"  search  :data="employeeCOEs">

            <template slot="thead">
                <vs-th sort-key="createdOn">Date Applied</vs-th>
                <vs-th sort-key="leaveTypeId">Type of Request</vs-th>
                <vs-th sort-key="fromDate">From Date</vs-th>
                <vs-th>To Date</vs-th>
                <vs-th>No Of Days</vs-th>
                <vs-th>Reason</vs-th>
                <vs-th>Approvers</vs-th>
                <vs-th><vs-icon  color="primary" icon-pack="feather" icon="icon-paperclip"  /></vs-th>
                <vs-th>Status</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Actions</vs-th>
            </template>

            <!-- <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].createdOn">
                        {{data[indextr].createdOn | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].leaveTypeId">
                        {{data[indextr].leaveType.leaveTypeName}}
                    </vs-td>
                    <vs-td :data="data[indextr].fromDate">
                        {{data[indextr].fromDate | fulldate}}
                    </vs-td>
                    <vs-td :data="data[indextr].toDate">
                        {{data[indextr].toDate | fulldate }}
                    </vs-td>
                    <vs-td :data="data[indextr].noOfDays">
                        {{data[indextr].noOfDays}}
                    </vs-td>
                    <vs-td :data="data[indextr].reason">
                        {{data[indextr].reason}}
                    </vs-td>
                    <vs-td >
                        <ul class="users-liked user-list">
                            <li :key="indextd" v-for="(user, indextd) in data[indextr].approversLMs">
                                <vx-tooltip :text="user.approver.fullName">
                                    <vs-avatar v-if="user.approver.photoUrl != ''" class="border-2 border-white border-solid -m-1" size="30px" :src="user.approver.photoUrl" />
                                    <vs-avatar v-else class="border-2 border-white border-solid -m-1" size="30px" :text="user.approver.fullName" :color="user.approver.fullName.length < 12 ? 'success' : user.approver.fullName.length <= 15 ? 'primary' : user.approver.fullName.length <= 20 ? 'warning' : 'danger'"/>

                                </vx-tooltip>
                            </li>
                        </ul>
                    </vs-td>
                    <vs-td  :data="data[indextr].photoId" >
                        <vs-icon v-show="data[indextr].photoId != '' && data[indextr].photoId != null" @click="downloadFile(data[indextr].photoId)"  color="primary" icon-pack="feather" icon="icon-paperclip"  />
                    </vs-td>
                    <vs-td >
                        <span class="flex items-center px-2 py-1 rounded"><div v-bind:class="
                            data[indextr].isCancelled == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' :
                            data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false ? 'h-3 w-3 rounded-full mr-2 bg-warning' :
                            data[indextr].approversLMs[0].isApproved == true ? 'h-3 w-3 rounded-full mr-2 bg-success' :
                            data[indextr].approversLMs[0].isRevised == true ? 'h-3 w-3 rounded-full mr-2 bg-primary' :
                            data[indextr].approversLMs[0].isRetracted == true ? 'h-3 w-3 rounded-full mr-2 bg-dark' :
                            data[indextr].approversLMs[0].isDenied == true ? 'h-3 w-3 rounded-full mr-2 bg-danger' : ''"/>
                                {{data[indextr].isCancelled == true ? 'Cancelled' :
                                 data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Draft':
                                 data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false  ? 'Pending' :
                                 data[indextr].approversLMs[0].isApproved == true ? 'Approved' :
                                 data[indextr].approversLMs[0].isRevised == true ? 'For Revision' :
                                 data[indextr].approversLMs[0].isRetracted == true ? 'Retracted' :
                                 data[indextr].approversLMs[0].isDenied == true ? 'Denied' : ''}}
                        </span>
                    </vs-td>
                    <vs-td :data="data[indextr].approversLMs[0].comments">
                        {{data[indextr].approversLMs[0].comments }}
                    </vs-td>
                    <vs-td>
                        <div class="vx-row">
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Edit' :
                                data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false ? 'Un-Submit' :
                                data[indextr].approversLMs[0].isApproved == true  ? 'Retract' :
                                data[indextr].approversLMs[0].isRevised == true ? ' Edit' :
                                data[indextr].approversLMs[0].isRetracted == true ? 'Edit' : ''">
                                <vs-button class="mr-3 mb-2" @click="openEditCOE(data[indextr].employeeFiledCOEId)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="success" type="border" icon-pack="feather" icon="icon-edit-2" ></vs-button>
                                <vs-button class="mr-3 mb-2" @click="promptUnSubmitDialog(data[indextr].employeeFiledCOEId, data[indextr].approversLMs[0].approver)" v-else-if="data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false" color="warning" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                <vs-button class="mr-3 mb-2" @click="promptRetrackDialog(data[indextr].employeeFiledCOEId, data[indextr].approversLMs[0].approver)" v-else-if="data[indextr].approversLMs[0].isApproved == true && (getFromDate(data[indextr].fromDate)) > getCurrentDate " color="danger" type="border" icon-pack="feather" icon="icon-rotate-ccw"></vs-button>
                                <vs-button class="mr-3 mb-2" @click="openEditCOE(data[indextr].employeeFiledCOEId)"  v-else-if="data[indextr].approversLMs[0].isRevised == true" color="success" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                           
                                </vx-tooltip>
                            </div>
                            <div class="flex">
                                <vx-tooltip v-bind:text="data[indextr].isDraft == true && data[indextr].isSubmitted == false ? 'Cancel' :
                                data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false ? 'Cancel' :
                                data[indextr].approversLMs[0].isRevised == true ? ' Cancel' :
                                data[indextr].approversLMs[0].isRetracted == true ? 'Cancel' : ''">
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledCOEId, data[indextr].approversLMs[0].approver)" v-if="data[indextr].isDraft == true && data[indextr].isSubmitted == false"  color="danger" type="border" icon-pack="feather" icon="icon-x" ></vs-button>
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledCOEId, data[indextr].approversLMs[0].approver)" v-else-if="data[indextr].isSubmitted == true && data[indextr].approversLMs[0].isApproved == false & data[indextr].approversLMs[0].isRevised == false && data[indextr].approversLMs[0].isRetracted == false && data[indextr].approversLMs[0].isDenied == false" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
                                <vs-button class="mb-2" @click="promptCancelDialog(data[indextr].employeeFiledCOEId, data[indextr].approversLMs[0].approver)" v-else-if="data[indextr].approversLMs[0].isRevised == true" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>

                                </vx-tooltip>
                            </div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template> -->
        </vs-table>

    </vx-card>



        <!-- ADD LEAVE -->
        <vs-prompt
            class="email-compose"
            title="Apply COE"
            accept-text= "Submit"
            @accept="onAddCOE"
            :is-valid="validForm"
            :active.sync="activePromptAddCOE">
            <vx-card title="Fill-out the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getCOETypes"> -->


            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">COE Type</span><span style="color:red">*</span>
                    <v-select name="leaveType-name" v-model="leaveType" label="leaveTypeName" :options="getCOEBenefits"/>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                    <!-- <flat-pickr  name="start-date" class="w-full" v-model="fromDate" :disabledDates="disabledDates" :config="configFromdateTimePicker" v-validate="'required'" @on-change="onFromChange"  /> -->
                    <datepicker name="start-date"   class="w-full" v-model="fromDate" v-validate="'required'" :disabledDates="disabledDates.disabledDates" @on-change="onFromChange" />
                </div>
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">End Date</span><span style="color:red">*</span>
                    <!-- <flat-pickr  name="end-date" class="w-full" v-model="toDate" :disabledDates="disabledDatesTo" :config="configTodateTimePicker" v-validate="'required'" @on-change="onToChange" /> -->
                    <datepicker name="end-date" class="w-full" v-model="toDate" v-validate="'required'" :disabledDates="disabledDates.disabledDates"  @on-change="onToChange" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-4">
                   <vs-switch v-model="isMorningFrom">
                        <span  class="text-sm" slot="on">PM</span>
                        <span  class="text-sm" slot="off">AM</span>
                    </vs-switch>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-4" >
                    <vs-switch v-model="isMorningTo">
                        <span  class="text-sm" slot="on">PM</span>
                        <span  class="text-sm" slot="off">AM</span>
                    </vs-switch>
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col sm:w-3/4  mb-2" >
                    <span  class="text-sm">No of Days : </span>
                    <vs-input v-model="noOfDays"/>

                    <!-- <span class="text-white bg-primary p-2 rounded" v-if="noOfDays > 1"> {{noOfDays}} days</span><span class="text-white bg-primary p-2 rounded" v-else>{{noOfDays}} day</span> -->
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reason</span><span v-show="leaveType.isRequiredReason"  style="color:red">*</span>
                    <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="reason"></vs-input>
                    <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <span class="text-sm">Approvers</span><span style="color:red">*</span>
                    <v-select class="w-full" v-model="approvers" label="fullName" :options="getApprovers" />
                    <!-- <vs-select  class="selectExample w-full" multiple v-model="approvers"  >
                        <vs-select-item  :key="index" :value="item.approverId" :text="item.approver.firstName + ' ' + item.approver.lastName" v-for="(item, index) in getApprovers" v-validate="'required'"  />
                    </vs-select> -->
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2" v-show="leaveType.isAttachment">
                
                <!-- <div class="vx-col w-full mb-6"> -->
                    <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar" text="Attachments"
                           />
                     
                     <!-- <vs-upload    accept="image/*" action="http://19.168.0.22:8080/api/photo/upload?UserId=&Title=&Dscription&IsPublic=true&Type=png&FileName=&file=" + data  class="compose-mail-attachment" v-show="this.leaveType.isAttachment && this.leaveType.maxCount < noOfDays"   text="Attachment"  :show-upload-button="false"  @on-success="successUpload" /> -->
                <!-- </div> -->
            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>




        <!-- EDIT LEAVE -->
        <vs-prompt
            class="email-compose"
            title="Edit COE"
            accept-text= "Submit"
            @accept="onEditCOE"
            :is-valid="validForm"
            :active.sync="activePromptEditCOE">
            <vx-card title="Edit the following information">
             <!-- <VuePerfectScrollbar class="scroll-area" :settings="getCOETypes"> -->


            <div class="vx-row mb-3">
                <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                    <span  class="text-sm">COE Type</span><span style="color:red">*</span>
                    <v-select name="event-name" v-model="leaveType" label="leaveTypeName" :options="getCOEBenefits"/>

                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                    <!-- <flat-pickr  name="start-date" class="w-full" v-model="fromDate" :disabledDates="disabledDates" :config="configFromdateTimePicker" v-validate="'required'" @on-change="onFromChange"  /> -->
                    <datepicker name="start-date"   class="w-full" v-model="fromDate" v-validate="'required'" :disabledDates="disabledDates.disabledDates" @on-change="onFromChange" />
                </div>
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">End Date</span><span style="color:red">*</span>
                    <!-- <flat-pickr  name="end-date" class="w-full" v-model="toDate" :disabledDates="disabledDatesTo" :config="configTodateTimePicker" v-validate="'required'" @on-change="onToChange" /> -->
                    <datepicker name="end-date" class="w-full" v-model="toDate" v-validate="'required'" :disabledDates="disabledDates.disabledDates"  @on-change="onToChange" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-4">
                   <vs-switch v-model="isMorningFrom">
                        <span  class="text-sm" slot="on">PM</span>
                        <span  class="text-sm" slot="off">AM</span>
                    </vs-switch>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-4" >
                    <vs-switch v-model="isMorningTo">
                        <span  class="text-sm" slot="on">PM</span>
                        <span  class="text-sm" slot="off">AM</span>
                    </vs-switch>
                </div>
            </div>
           <div class="vx-row mb-3">
                <div class="vx-col sm:w-3/4  mb-2" >
                    <span  class="text-sm">No of Days : </span>
                    <vs-input v-model="noOfDays"/>

                    <!-- <span class="text-white bg-primary p-2 rounded" v-if="noOfDays > 1"> {{noOfDays}} days</span><span class="text-white bg-primary p-2 rounded" v-else>{{noOfDays}} day</span> -->
                </div>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full mb-2">
                    <span  class="text-sm">Reason</span><span v-show="leaveType.isRequiredReason"  style="color:red">*</span>
                    <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="reason"></vs-input>
                    <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <span class="text-sm">Approvers</span><span style="color:red">*</span>
                    <v-select  class="w-full" v-model="approvers" label="fullName" :options="getApprovers"></v-select>
                    <!-- <vs-select  class="selectExample w-full" multiple  v-model="approvers" >
                        <vs-select-item  :key="index" :value="item.approverId" :text="item.approver.firstName + ' ' + item.approver.lastName" v-for="(item, index) in getApprovers" v-validate="'required'"  />
                    </vs-select> -->
                </div>
            </div>
            <div class="vx-row mb-2">
                <div class="vx-col w-full mb-2">
                    <vs-checkbox color="rgb(21, 67, 252)" v-model="isDraft">Save As Draft?</vs-checkbox>
                </div>
            </div>
            <div class="vx-row mb-2" v-show="leaveType.isAttachment">
                <div  class="vx-col w-full mb-2">
                    <vs-button v-show="!isFileReplaced" @click="downloadFile(photoId)" color="primary" type="border" :badge=3 icon-pack="feather" icon="icon-download">{{attachmentName}}</vs-button>
                </div>
                
                    <vs-upload 
                        limit = 1
                        @on-success="successUpload"
                        @on-delete="deleteUpload"
                        :show-upload-button="false"
                        @change="updateCurrImg($event)"
                        v-bind:headers="{'Content-Type': 'multipart/form-data'}"
                        class="compose-mail-attachment" ref="upldphto" accept=".doc,.jpg,.jpeg,.png,.pdf,.zip,.rar"  text="Attachments"/>

            </div>
             <!-- </VuePerfectScrollbar> -->
            </vx-card>
        </vs-prompt>


        <!-- UNSUBMITDIALOG -->
        <vs-prompt
            title="COE Un-Submit"
            @accept="onUnSubmit"
            accept-text= "Yes"
            :active.sync="activeUnSubmitDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            </div>
        </vs-prompt>


         <!-- RETRACK ADD COMMENT -->
        <vs-prompt
            title = "Retract COE"
            @accept="onRetracked"
            accept-text= "Yes"
            :active.sync="activeRetrackDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="Remarks" v-model="remarks" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>


         <!-- CANCEL LEAVE -->
        <vs-prompt
            title = "COE Cancel"
            @accept="onCancelled"
            accept-text= "Yes"
            :active.sync="activeCancelDialog">
            <div class="con-exemple-prompt">
                Are you sure you want to <b>continue?</b>.
            <vs-input placeholder="Remarks" v-model="remarks" class="mt-4 mb-2 w-full" />

            <vs-alert :vs-active="!validRemarks" color="danger" vs-icon="new_releases" >
                This can not be empty please enter remarks
            </vs-alert>
            </div>
        </vs-prompt>

    </div>



</template>


<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';



export default {
    data() {
        return {

        }
    },
    methods: {
        promptUnSubmitDialog(Id, approver) {
            this.remarks = ''
            this.employeeFiledCOEId = Id
            this.approvers = approver
            this.activeUnSubmitDialog = true
        },
        promptRetrackDialog(Id, approver) {
            this.remarks = ''
            this.employeeFiledCOEId = Id
            this.approvers = approver
            this.activeRetrackDialog = true
        },
        promptCancelDialog(Id, approver) {
            this.remarks = ''
            this.employeeFiledCOEId = Id
            this.approvers = approver
            this.activeCancelDialog = true
        },

    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
// @import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>